import React from "react";
import PublicNavbar from "../../components/PublicNavbar";
import Footer from "../../components/Footer";

export default function LegalCookies() {
  return (
    <div className="min-h-screen bg-white">
      <PublicNavbar />
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-16">
        <div className="overline">Informations légales</div>
        <h1 className="font-heading text-3xl sm:text-4xl font-medium tracking-tight text-slate-900 mt-2">
          Politique de cookies
        </h1>
        <div className="text-xs text-slate-500 mt-1">Dernière mise à jour : 13 juin 2026</div>

        <div className="prose prose-slate max-w-none mt-10 text-[15px] leading-relaxed space-y-8">
          <Section title="1. Qu'est-ce qu'un cookie ?">
            <p>
              Un cookie est un petit fichier texte déposé sur votre appareil lors de la consultation
              d'un site internet. Il permet notamment de mémoriser vos préférences et d'assurer le bon
              fonctionnement des services.
            </p>
          </Section>

          <Section title="2. Cookies utilisés par Junago">
            <p>Junago utilise un nombre minimal de cookies, strictement nécessaires :</p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Cookies de session</strong> : maintien de votre connexion sécurisée à la plateforme.</li>
              <li><strong>Cookies de préférences</strong> : mémorisation de vos réglages d'affichage.</li>
              <li><strong>Cookies de paiement (Stripe)</strong> : déposés par notre prestataire de paiement pour sécuriser les transactions et lutter contre la fraude.</li>
            </ul>
            <p>Junago n'utilise aucun cookie publicitaire ni de revente de données à des tiers.</p>
          </Section>

          <Section title="3. Durée de conservation">
            <p>
              Les cookies de session expirent à la fermeture de votre navigateur ou après une période
              d'inactivité. Les cookies de préférences sont conservés au maximum 13 mois.
            </p>
          </Section>

          <Section title="4. Gérer vos cookies">
            <p>
              Vous pouvez à tout moment configurer votre navigateur pour refuser ou supprimer les
              cookies. Le refus des cookies strictement nécessaires peut toutefois empêcher la
              connexion à votre espace Junago.
            </p>
          </Section>

          <Section title="5. Contact">
            <p>
              Pour toute question relative à cette politique :{" "}
              <a className="text-violet-600 underline" href="mailto:contact@junago.fr">contact@junago.fr</a>.
            </p>
          </Section>
        </div>
      </div>
      <Footer />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-heading text-lg font-medium text-slate-900 mb-2">{title}</h2>
      <div className="text-slate-600 space-y-3">{children}</div>
    </section>
  );
}
